<template>
  <div class="container">
    <div class="title">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item>业务管理</el-breadcrumb-item>
        <el-breadcrumb-item>账单管理</el-breadcrumb-item>
        <el-breadcrumb-item>账单列表</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <el-card class="box-card">
      <el-tabs v-model="activeTab" type="card" @tab-click="handleTabClick">
        <el-tab-pane label="资源交付" name="resource">
          <ResourceDelivery ref="resourceDelivery" />
        </el-tab-pane>
        <el-tab-pane label="服务器" name="server">
          <ServerBill ref="serverBill" />
        </el-tab-pane>
        <el-tab-pane label="TPC" name="TPC">
          <TPCBill ref="TPCBill" />
        </el-tab-pane>
        <el-tab-pane label="网络" name="network">
          <NetworkBill ref="networkBill" />
        </el-tab-pane>
        <el-tab-pane label="资产" name="asset">
          <AssetBill ref="assetBill" />
        </el-tab-pane>
        <el-tab-pane label="改造" name="renovation">
          <RenovationBill ref="renovationBill" />
        </el-tab-pane>
        <el-tab-pane label="IDC现场监管" name="idc_regulation_reconciliation">
          <IdcRegulationReconciliationBill ref="idcRegulationReconciliationBill" />
        </el-tab-pane>
      </el-tabs>
    </el-card>
  </div>
</template>

<script>
import AssetBill from './components/AssetBill.vue';
import IdcRegulationReconciliationBill from './components/IdcRegulationReconciliationBill.vue';
import NetworkBill from './components/NetworkBill.vue';
import RenovationBill from './components/RenovationBill.vue';
import ResourceDelivery from './components/ResourceDelivery.vue';
import ServerBill from './components/ServerBill.vue';
import TPCBill from './components/TPCBill.vue';

export default {
  name: 'BillList',
  components: {
    ResourceDelivery,
    ServerBill,
    TPCBill,
    NetworkBill,
    AssetBill,
    RenovationBill,
    IdcRegulationReconciliationBill,
  },
  data() {
    return {
      activeTab: 'resource',
    };
  },
  mounted() {
    // 页面加载时初始化默认tab的数据
    this.$nextTick(() => {
      if (this.$refs.resourceDelivery && this.$refs.resourceDelivery.fetchFaultData) {
        this.$refs.resourceDelivery.fetchFaultData();
      }
    });
  },
  methods: {
    handleTabClick(tab) {
      // 切换tab时调用对应组件的列表接口
      console.log('切换到tab:', tab.name);

      // 根据tab名称调用对应组件的数据获取方法
      this.$nextTick(() => {
        switch (tab.name) {
          case 'resource':
            if (this.$refs.resourceDelivery && this.$refs.resourceDelivery.fetchFaultData) {
              this.$refs.resourceDelivery.fetchFaultData();
            }
            break;
          case 'server':
            if (this.$refs.serverBill && this.$refs.serverBill.fetchFaultData) {
              this.$refs.serverBill.fetchFaultData();
            }
            break;
          case 'TPC':
            if (this.$refs.TPCBill && this.$refs.TPCBill.fetchFaultData) {
              this.$refs.TPCBill.fetchFaultData();
            }
            break;
          case 'network':
            if (this.$refs.networkBill && this.$refs.networkBill.fetchFaultData) {
              this.$refs.networkBill.fetchFaultData();
            }
            break;
          case 'asset':
            if (this.$refs.assetBill && this.$refs.assetBill.fetchFaultData) {
              this.$refs.assetBill.fetchFaultData();
            }
            break;
          case 'renovation':
            if (this.$refs.renovationBill && this.$refs.renovationBill.fetchFaultData) {
              this.$refs.renovationBill.fetchFaultData();
            }
            break;
          case 'idc_regulation_reconciliation':
            if (this.$refs.idcRegulationReconciliationBill && this.$refs.idcRegulationReconciliationBill.fetchFaultData) {
              this.$refs.idcRegulationReconciliationBill.fetchFaultData();
            }
            break;
        }
      });
    },
  },
};
</script>

<style scoped>
.container {
  padding: 20px;
}

.title {
  font-size: 24px;
  font-weight: bold;
  margin-bottom: 30px;
}

.box-card {
  margin-bottom: 20px;
}

::v-deep .el-card {
  border: none;
}

::v-deep .el-card__body,
.el-main {
  padding: 0 !important;
}
</style>
